import {z} from 'zod'

const boolEnvVar = z
  .string()
  .optional()
  .transform((s) => s == 'true')

export const envVars = z
  .object({
    VITE_NODE_ENV: z.string(),
    VITE_IS_REACTQUERYDEVTOOLS_ENABLED: boolEnvVar,
    VITE_SENTRY_DNS: z.string(),
    VITE_API_URL: z.string(),
    VITE_INTERNAL_API_URL: z.string(),
    VITE_HB_PROXY: z.string(),
    VITE_JSON_BASEPATH: z.string(),
    VITE_IS_MSW_ENABLED: boolEnvVar,
    VITE_TOS_URL: z.string().url(),
    VITE_IS_REQUESTS_OVERVIEW_ENABLED: boolEnvVar,
  })
  .parse(import.meta.env)
